// extracted by mini-css-extract-plugin
export var wordContainer = "_ov-0";